import { AppBar, Menu, Tab } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import { FeedStyleClasses, TabLargeStyle, TimelineStyleClasses } from "assets/jss/common-styles";
import AdvFilter, { AdvFilterCommand, AdvFilterComponent, AdvFilterPicker, AdvFilterResult } from "components/AdvFilter";
import { CmdCourseExpiring, CmdCourseNotStarted, CmdPublishEndDate, CmdPublishStartDate, CmdTopic, CmdWithAward, CommandLabels } from "components/AdvFilter/CommonCommands";
import { AppBarTabs } from "components/AppTabs";
import ButtonOrderBy from "components/Buttons/ButtonOrderBy";
import ButtonResetFilter from "components/Buttons/ButtonResetFilter";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import CountFilter from "components/CountFilter";
import IconCircle from "components/Icons/IconCircle";
import { MuiFilterAppBar, MuiFilterLine, MuiFilterToolbar } from "components/MuiExtras/Filter";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiMenuItemChecked from "components/MuiExtras/MuiMenuItemChecked";
import MuiPushRight from "components/MuiExtras/MuiPushRight";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import AppMessage from "components/Translations/AppMessage";
import LibUtils from "lib/LibUtils";
import { FeedType, PublicationType } from "models/ApiEnums";
import { FeedCourseFilter, FeedCourseOrderBy } from "models/ApiModels";
import queryString from 'query-string';
import * as React from "react";
import { useTranslation, WithTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { AppState } from "store/app/reducer";
import * as FeedActions from 'store/feed/actions';
import { FeedState } from "store/feed/reducer";
import { ApplicationState } from "store/rootReducer";
import { CourseActions } from "views/Publication/Components/CourseModels";
import CardManager from "views/Timeline/Components/CardManager";
import { getPublicationSecondViewAction } from "views/Timeline/Components/FeedHelpers";
import { ITimelineDispatchProps } from "views/Timeline/TimelineCommons";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IStateProps {
    feed: FeedState;
    app: AppState;
}

interface IState {
    advFilters: AdvFilterResult[];
    filter: FeedCourseFilter;
    orderBy: FeedCourseOrderBy;
    orderByMenuAnchorEl: any,
    dialog: any;
}

interface IStateSaved {
    feedType: FeedType;
    state: IState;
}

interface IProps {
    timestamp?: Date;
}

export interface ITimelineCoursesRouteState {
    id: string;
}


interface IDispathProps extends ITimelineDispatchProps {
    onGetFeed: (filter: FeedCourseFilter, orderBy: FeedCourseOrderBy, startIndex: number, endIndex: number) => Promise<any>;
}

type Props = IProps & IDispathProps & IStateProps & WithSnackbar & WithTranslation & RouteComponentProps<ITimelineCoursesRouteState, any, any> & WithStyles<typeof TimelineStyleClasses> & WithStyles<typeof FeedStyleClasses>;

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IRenderMenu {
    category: FeedType;
    onChange: (event: React.ChangeEvent<{}>, value: any) => void;
}

const RenderMenuBar: React.FC<Props & IRenderMenu> = (props) => {
    const { t } = useTranslation();
    return (
        <div className={props.classes.filterTabContainer}>
            <AppBar position="static" color="default" classes={{ root: props.classes.appTabFilterRoot }}>
                <AppBarTabs
                    centered
                    value={props.category}
                    onChange={props.onChange}
                >
                    <Tab
                        value={FeedType.CourseAutoEnroll}
                        label={t("Views.Timeline.TimelineCourses.TabRegistration")}
                        style={TabLargeStyle}
                        disabled={props.feed.loading}
                    />
                    <Tab
                        value={FeedType.CourseEnrolled}
                        label={
                            <span>
                                {
                                    props.app.callouts.findIndex(p => p.feed == FeedType.CourseEnrolled && p.callout === true) > -1 &&
                                    <MuiColor variant="warning"><IconCircle fixedWidth /></MuiColor>
                                }
                                <span>{t("Views.Timeline.TimelineCourses.TabComplete")}</span>
                            </span>
                        }
                        style={TabLargeStyle}
                        disabled={props.feed.loading}
                    />
                    <Tab
                        value={FeedType.CourseCompleted}
                        label={t("Views.Timeline.TimelineCourses.TabReview")}
                        style={TabLargeStyle}
                        disabled={props.feed.loading}
                    />
                </AppBarTabs>
            </AppBar>
        </div>
    );
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class TimelineCoursesComponent extends React.PureComponent<Props, IState> {

    private advFilterRef: AdvFilterComponent;
    private currentFilter: FeedCourseFilter;
    private currentOrderBy: FeedCourseOrderBy;

    private saveState: IStateSaved[] = [];

    constructor(props: Props) {
        super(props);

        this.saveState.push({ feedType: FeedType.CourseAutoEnroll, state: this.recoverState(FeedType.CourseAutoEnroll) });
        this.saveState.push({ feedType: FeedType.CourseCompleted, state: this.recoverState(FeedType.CourseCompleted) });
        this.saveState.push({ feedType: FeedType.CourseEnrolled, state: this.recoverState(FeedType.CourseEnrolled) });

        this.state = this.saveState[0].state;
        this.currentFilter = this.state.filter;
        this.currentOrderBy = this.state.orderBy;

        const qs = queryString.parse(document.location.search);
        var initialId = props.location?.state?.id ?? qs["id"];
        if (initialId != null) this.state = this.makeInitialFilter(initialId, this.state);
    }

    ///
    private makeInitialFilter(initialId: string, currentState: IState): IState {
        var filter = { ...currentState.filter, courseId: initialId, category: FeedType.CourseAutoEnroll };
        this.currentFilter = filter;

        return { ...currentState, filter };
    }

    ///
    private reloadLocationState() {
        this.saveCurrentState();

        var initialId = this.props.location.state.id;
        var tabState = this.recoverState(FeedType.CourseAutoEnroll);
        var newTabState = this.makeInitialFilter(initialId, tabState);

        this.props.onFeedReset();

        this.setState(newTabState);
    }

    ///
    private saveCurrentState() {
        var item = this.saveState.find(p => p.feedType == this.state.filter.category);
        item.state = this.state;
    }

    ///
    private recoverState(feedType: FeedType): IState {

        var item = this.saveState.find(p => p.feedType == feedType);

        if (item == null)
            item = {
                feedType: feedType,
                state: {
                    advFilters: [],
                    filter: {
                        category: feedType,
                        searchText: null,
                        startDate: null,
                        endDate: null,
                        topicId: null,
                        withAward: null,
                        expiring: null,
                        notStarted: null
                    },
                    orderBy: FeedCourseOrderBy.Title,
                    orderByMenuAnchorEl: null,
                    dialog: null
                }
            };

        this.currentFilter = item.state.filter;
        this.currentOrderBy = item.state.orderBy;

        return item.state;
    }

    ///
    private handleCustomAction = (uid: string, publicationId: string, publicationType: PublicationType, action: CourseActions): Promise<boolean> => {

        if (action.feed.actionName == "view") {
            return new Promise<boolean>((resolve) => {
                getPublicationSecondViewAction(publicationType, publicationId)();
                resolve(true);
            });
        }

        return this.props.onCustomAction(uid, publicationId, publicationType, action)
            .then((result) => {

                if (action.feed.actionName == "enroll") {

                    if (result) {
                        getPublicationSecondViewAction(publicationType, publicationId)();
                        this.handleTabSelection(null, FeedType.CourseEnrolled);
                    }
                    else this.props.snackbar.showMessage(<AppMessage resource="OperationFailed" />, "error");
                }
                else if (action.feed.actionName == "cancelEnroll") {
                    if (result) this.props.snackbar.showMessage(this.props.t("Views.Timeline.TimelineCourses.CancelEnrollmentSuccess"), "success");
                    else this.props.snackbar.showMessage(<AppMessage resource="OperationFailed" />, "error");
                }

                return result;
            });
    };

    ///
    private handleTabSelection = (event: React.ChangeEvent<{}>, value: any) => {
        if (this.props.feed.loading && this.state.filter.category == value) {
            return;
        }

        this.saveCurrentState();

        var newState = this.recoverState(value);

        this.props.onFeedReset();

        this.setState(newState);
    };

    //#region FILTER

    ///
    private get commands(): AdvFilterCommand[] {
        const cmdLabels = CommandLabels();
        return [
            { keyword: CmdTopic, displayName: cmdLabels[CmdTopic], picker: AdvFilterPicker.Topic, canRepeat: false, group: 1 },
            { keyword: CmdPublishStartDate, displayName: cmdLabels[CmdPublishStartDate], picker: AdvFilterPicker.Calendar, group: 2 },
            { keyword: CmdPublishEndDate, displayName: cmdLabels[CmdPublishEndDate], picker: AdvFilterPicker.Calendar, group: 2 },
            { keyword: CmdWithAward, displayName: cmdLabels[CmdWithAward], group: 2 },
            { keyword: CmdCourseNotStarted, displayName: cmdLabels[CmdCourseNotStarted], group: 3 },
            { keyword: CmdCourseExpiring, displayName: cmdLabels[CmdCourseExpiring], group: 3 }
        ];
    }

    ///
    private getCommands() {
        return (this.state.filter.category != FeedType.CourseEnrolled)
            ? this.commands.filter(p => p.group != 3)
            : this.commands;
    }

    ///
    private getOrderByItems() {
        const { orderBy, filter: { category } } = this.state;

        if (category == FeedType.CourseEnrolled) {

            return [
                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.Name")} value={FeedCourseOrderBy.Title} currentSelection={orderBy} onClick={this.applyOrder} />,
                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.CourseShortestCompletePercent")} value={FeedCourseOrderBy.LessProgress} currentSelection={orderBy} onClick={this.applyOrder} />,
                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.CourseShortestDeadline")} value={FeedCourseOrderBy.LessDeadline} currentSelection={orderBy} onClick={this.applyOrder} />
            ];
        }

        return (
            [
                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.Name")} value={FeedCourseOrderBy.Title} currentSelection={orderBy} onClick={this.applyOrder} />,
                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostRecent")} value={FeedCourseOrderBy.MostRecent} currentSelection={orderBy} onClick={this.applyOrder} />,
                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostSubscribed")} value={FeedCourseOrderBy.MostEnrolled} currentSelection={orderBy} onClick={this.applyOrder} />,
                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostLiked")} value={FeedCourseOrderBy.MostLiked} currentSelection={orderBy} onClick={this.applyOrder} />,
                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostCommented")} value={FeedCourseOrderBy.MostCommented} currentSelection={orderBy} onClick={this.applyOrder} />
            ]);
    }

    ///
    private clearFilter(): Partial<FeedCourseFilter> {
        return {
            searchText: null,
            startDate: null,
            endDate: null,
            topicId: null,
            withAward: null,
            expiring: null,
            notStarted: null,
            courseId: null,
        };
    }

    ///
    private buildFilter(searchText: string, advFilters: AdvFilterResult[]) {
        var filter: Partial<FeedCourseFilter> = {};

        filter.searchText = searchText.length == 0 ? null : searchText;

        const topic = advFilters.find(p => p.keyword == CmdTopic);
        filter.topicId = topic ? topic.value : null;

        var dt = advFilters.find(x => x.keyword == CmdPublishStartDate);
        filter.startDate = dt ? (dt.value as Date).putStartOfDay() : null;

        dt = advFilters.find(x => x.keyword == CmdPublishEndDate);
        filter.endDate = dt ? (dt.value as Date).putEndOfDay() : null;

        filter.withAward = advFilters.findIndex(x => x.keyword == CmdWithAward) > -1;
        filter.expiring = advFilters.findIndex(x => x.keyword == CmdCourseExpiring) > -1;
        filter.notStarted = advFilters.findIndex(x => x.keyword == CmdCourseNotStarted) > -1;

        return filter;
    }

    ///
    private isFiltered() {
        return !LibUtils.isAllPropertiesWithValue(this.state.filter, null, ["category"]);
    }

    ///
    private closeOrderBy = () => {
        this.setState({ orderByMenuAnchorEl: null });
    };

    ///
    private applyOrder = (orderBy: FeedCourseOrderBy) => {
        this.currentOrderBy = orderBy;
        this.setState({ orderBy, orderByMenuAnchorEl: null }, () => this.props.onFeedReset());
    };

    ///
    private handleUpdateFilter = (searchText: string, advFilters: AdvFilterResult[]) => {

        var newFilter = (searchText.length == 0 && advFilters.length == 0)
            ? this.clearFilter()
            : this.buildFilter(searchText, advFilters);

        this.currentFilter = { ...this.state.filter, ...newFilter };

        this.setState(
            {
                advFilters,
                filter: this.currentFilter
            }, () => this.props.onFeedReset()
        );
    };

    ///
    private renderAdvFilter(): JSX.Element {
        return (
            <MuiFilterAppBar position="static">
                <MuiFilterToolbar variant="dense" >
                    <MuiFilterLine>
                        <AdvFilter
                            id="advfilter"
                            commands={this.getCommands()}
                            innerRef={(ref) => this.advFilterRef = ref}
                            placeHolder={this.props.t("Common.Filter.Adv.InputPlaceholder")}
                            placeHolderFocus={this.props.t("Common.Filter.Adv.InputPlaceholderFocus")}
                            title={this.props.t("Common.Filter.Adv.InputTitleEnterToFilter")}
                            selectedCommands={this.state.advFilters}
                            inputValue={this.currentFilter.searchText}
                            underlineColor="white"
                            onUpdateSelection={this.handleUpdateFilter}
                        />

                        <MuiPushRight>
                            <ButtonOrderBy
                                onClick={
                                    (e) => {
                                        this.setState({ orderByMenuAnchorEl: e.currentTarget });
                                    }
                                }
                            />
                            <Menu
                                anchorEl={this.state.orderByMenuAnchorEl}
                                open={this.state.orderByMenuAnchorEl != null}
                                onClose={this.closeOrderBy}
                            >
                                {this.getOrderByItems()}
                            </Menu>
                        </MuiPushRight>

                    </MuiFilterLine>
                </MuiFilterToolbar>
            </MuiFilterAppBar>
        );
    }

    //#endregion

    ///
    public componentDidMount() {
        this.props.onFeedReset();
    }

    ///
    public componentWillUnmount() {
        this.props.onFeedReset();
    }

    ///
    public componentDidUpdate(prevProps: Props) {
        if ((prevProps.timestamp != this.props.timestamp || prevProps.location.key !== this.props.location.key) && !this.props.feed.loading) {

            if (prevProps.location.key !== this.props.location.key && this.props.location.state != null) {
                this.reloadLocationState();
            }
            else {
                this.props.onFeedReset();
            }
        }
    }

    ///
    public render() {
        const { classes, feed, feed: { lastError, totalRecords, loading }, snackbar } = this.props;
        const { filter } = this.state;

        var notFoundMessage = "";
        switch (this.state.filter.category) {
            case FeedType.CourseAutoEnroll: notFoundMessage = this.props.t("Views.Timeline.TimelineCourses.TabRegistrationEmptyMessage"); break;
            case FeedType.CourseEnrolled: notFoundMessage = this.props.t("Views.Timeline.TimelineCourses.TabCompleteEmptyMessage"); break;
            case FeedType.CourseCompleted: notFoundMessage = this.props.t("Views.Timeline.TimelineCourses.TabReviewEmptyMessage"); break;
        }

        return (
            <div>

                <RenderMenuBar {...this.props} category={filter.category} onChange={this.handleTabSelection} />

                <div className={classes.timelineContainer}>

                    {this.state.dialog}

                    {
                        (totalRecords > 0 || this.isFiltered()) &&
                        <MuiContainer margin="normal">
                            {this.renderAdvFilter()}
                        </MuiContainer>
                    }

                    {
                        totalRecords > 0 &&
                        <MuiContainer margin="normal">
                            <CountFilter
                                count={totalRecords}
                                filtered={this.isFiltered()}
                                resource="Views.Timeline.TimelineCourses.Filter.CourseResultText"
                                filteredResource="Views.Timeline.TimelineCourses.Filter.CourseFilteredResultText"
                                onResetFilter={filter.courseId != null
                                    ? () => this.handleUpdateFilter("", [])
                                    : () => this.advFilterRef.resetFilter()}
                            />
                        </MuiContainer>
                    }

                    <CardManager
                        classes={classes}
                        feedType={filter.category}
                        feed={feed}
                        snackbar={snackbar}
                        onExpandPublication={this.props.onExpandPublication}
                        onReloadPublication={this.props.onReloadPublication}
                        onUpdatePublication={this.props.onUpdateFeedData}
                        onRemoveFromFeed={this.props.onRemoveFromFeed}
                        onGetFeed={(startIndex: number, endIndex: number) => { return this.props.onGetFeed(this.currentFilter, this.currentOrderBy, startIndex, endIndex); }}
                        onCustomAction={this.handleCustomAction}
                        onFeedReset={this.props.onFeedReset}
                    />


                    {
                        lastError != null
                            ? <RequestErrorReport error={lastError} />
                            : totalRecords == 0 && !loading && !this.isFiltered()
                                ? <MuiMessageBox variant="info" message={notFoundMessage} />
                                : totalRecords == 0 && !loading && this.isFiltered()
                                    ? (
                                        <MuiMessageBox
                                            variant="warning"
                                            action={<ButtonResetFilter color="warning" onClick={() => this.advFilterRef.resetFilter()} />}
                                            message={this.props.t("Views.Timeline.TimelineCourses.Filter.CourseFilteredResultText_zero")}
                                        />
                                    )
                                    : null
                    }
                </div>
            </div>
        );
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////

function mapStateToProps(state: ApplicationState): IStateProps {
    return {
        feed: state.feed,
        app: state.app
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<ApplicationState, void, Action<any>>, ownProps: IProps): IDispathProps {
    const action = new FeedActions.CourseFeedAction();

    return {
        onExpandPublication: (uid, publicationId) => dispatch(action.getPublicationFullContent(uid, publicationId)),
        onUpdateFeedData: (newItemDto) => dispatch(action.updateFeedData(newItemDto)),
        onRemoveFromFeed: (uid, publicationId) => dispatch(action.removeFeedData(uid, publicationId)),
        onFeedReset: () => dispatch(action.feedReset()),
        onCustomAction: (uid, publicationId, publicationType, customAction) => dispatch(action.customActions(uid, publicationId, publicationType, customAction)),
        onGetFeed: (filter, orderBy, startIndex, endIndex) => dispatch(action.getFeed(filter, orderBy, startIndex, endIndex)),
    };
}

const withAllStyles = withStyles(
    (theme) => ({
        ...TimelineStyleClasses(theme),
        ...FeedStyleClasses(theme),
    }),
    { withTheme: true },
);

const Timeline = connect<IStateProps, IDispathProps>(mapStateToProps, mapDispatchToProps)(withRouter(withSnackbar(withTranslation()(withAllStyles(TimelineCoursesComponent)))));

///////////////////////////////////////////////////////////////////////////

const TimelineCourses: React.FC<Props> = () => {
    return (
        <Timeline
            timestamp={new Date()}
        />
    );
};

export default TimelineCourses;